import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface UnshareConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  resourceTitle: string;
  resourceType: string;
  memberCount: number;
}

export function UnshareConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  resourceTitle,
  resourceType,
  memberCount,
}: UnshareConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remover todos os compartilhamentos?</AlertDialogTitle>
          <AlertDialogDescription>
            Você está prestes a remover o compartilhamento de{' '}
            <strong>"{resourceTitle}"</strong> ({resourceType}) com{' '}
            <strong>{memberCount} pessoa(s)</strong>.
            <br />
            <br />
            Essas pessoas perderão acesso imediatamente. Esta ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Remover compartilhamento
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
